import React from 'react';
import Table from '../../Table';
import moment from "moment";

function ApplicantsTable(props) {
	const title = "Manage Applicants";
	const columns = [
		{
			name: 'Login Name',
			selector: 'username',
			sortable: true,
			ignoreRowClick: true
		},
		{
			name: 'Name',
			sortable: true,
			selector: 'fname',
			ignoreRowClick: true,
			cell: row => {
				return (
					<span className="nameLabel">{`${row.fname || ''} ${row.lname || ''}`}</span>
				);
			}			
		},
		{
			name: "Status",
			selector: "snapshotStatus",
			sortable: true,
			ignoreRowClick: true,
			cell: row => {
				function statusToLabel(status) {
					switch (status) {
						case "PENDING_SUBMIT":
							//<a href="#"><i class="fas fa-paper-plane"></i></a>
							//<i class="fas fa-expand"></i>
							//<i class="fas fa-tools"></i>
							return (
								<span>Pending Submission <a href="#remind" onClick={(e) => { e.preventDefault(); props.handleApplicantClick('reminder', row); }}><i className="fas fa-paper-plane"></i></a></span>
							);
						case "SUBMITTED":
							//modal type: resubmit
							return (
								<span>Submitted <a href={ `/applications/${row.cobrands[0].id}/${row.snapshotId}` } target="_blank"><i className="fas fa-external-link-alt"></i></a></span>
							);
						case "PENDING_RESUBMIT":
							//<a href="#"><i class="fas fa-paper-plane"></i></a>
							//onClick={() => { props.handleApplicantClick(row.id, 'resubmitReminder') }}
							return (
								<span>Pending Resubmission <a href="#remind" onClick={(e) => { e.preventDefault(); props.handleApplicantClick('resubmitReminder', row); }}><i className="fas fa-paper-plane"></i></a></span>
							);
						case "RESUBMITTED":
							return (
								<span>Resubmitted <a href={ `/applications/${row.cobrands[0].id}/${row.snapshotId}` } target="_blank"><i className="fas fa-external-link-alt"></i></a></span>
							);
						default:
							return;
					}
				}
				return (
					<span>{ statusToLabel(row.snapshotStatus) }</span>
				);
			}
		},
		{
			name: "Created Date",
			selector: "lastUpdated",
			sortable: true,
			ignoreRowClick: true,
			cell: row => {
			  return (
				<span>
				  {moment
					.utc(row.lastUpdated)
					.local()
					.format("MM-DD-YYYY HH:mm")}
				</span>
			  );
			}
		}				
	];
	return (
		<Table
		  title={title}
		  columns={columns}
		  data={props.data}
		  pagination={true}
		  paginationPerPage={props.paginationPerPage}
		  paginationRowsPerPageOptions={[25, 50, 75, 100]}
		/>
	);
}

export default ApplicantsTable;